module.exports = __webpack_public_path__ + "static/media/rotenso.563daba9.jpg";